import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import StockholdersMeeting from "~/views/stockholders-meeting"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const apiContext = await getApiContext(
    [
      { url: "/formwithcontacts/list", code: "stockholders-meeting" },
      { url: "/calendar/element", code: "annual-meeting" },
    ],
    req ? req.headers.host : location.host,
  )

  const crumbs = generateCrumbs(req?.url)

  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
StockholdersMeeting.getInitialProps = getInitialProps

export default StockholdersMeeting
